{
    "version": 8,
    "name": "FE-Satellite",
    "metadata": {},
    "sources": {
        "raster-tiles": {
            "attribution": "<a target='_blank' href='https://www.esri.com/en-us/legal/terms/data-attributions'>Esri</a>, Maxar, Earthstar Geographics",
            "maxzoom": 23,
            "tiles": [
                "https://maps.geo.us-west-2.amazonaws.com/maps/v0/maps/femapsatellite/tiles/{z}/{x}/{y}?key=v1.public.eyJqdGkiOiI0MTE1ZmJmYy00ZTI3LTRjYjItYTdhYS0wNzA4MDIyNmZhMTMifTvYSG_PwsLei6wX9KG1-VZGIqkKWuE9fVwcM8QJHIlDpq1j7LGBXExqQYZ8svTwPCayfpfc48IqFzJewjgWOuOxSEj9lEAxVwO7co3yGMwTyc7btg58ZmG6FjOYD5FEjoryGs6jtKRnj1bt025LDJgSEdIVWIUHs9x73P0s4eHD5ACNL1t_2No80s2VJ4vEHAPaY1ZxFsOWHrCeRrEUDIx_7tqAE7ZB2_6NpxrgZSt7pr53GANBbE6b-yt2a6kggGYyecE62AlxoSdyWI4qYgX8x9-uDespmWqsqecj8ln7AbMTIy25eQyNjNKCgjAs0_p-V-PP5TCsNmfz8ixNRBc.MGFjMDA4ZmUtYWRiYy00NTgyLTg0Y2MtZTY3MzFlZDRmYTQ1"
            ],
            "type": "raster",
            "tileSize": 256
        },
        "terrain_source": {
            "type": "raster-dem",
            "encoding": "terrarium",
            "tiles": ["https://s3.amazonaws.com/elevation-tiles-prod/terrarium/{z}/{x}/{y}.png"],
            "tileSize": 256,
            "minzoom": 0,
            "maxzoom": 14
        }
    },
    "sprite": [
        {
            "id": "fe",
            "url": "static/map/CAEFESprite"
        }
    ],
    "sky": {
        "sky-color": "#88C6FC",
        "sky-horizon-blend": 0.8,
        "horizon-color": "#ffffff",
        "horizon-fog-blend": 0.8,
        "fog-color": "#ffffff",
        "fog-ground-blend": 0.5,
        "atmosphere-blend": 0
    },
    "light": {
        "anchor": "viewport",
        "position": [0, 210, 30],
        "color": "#ffffff",
        "intensity": 0
    },
    "state": {
        "text-color": { "default": "white" },
        "feNav_icon-color": { "default": "rgba(240,240,240,1)" },
        "feNav_text-color": { "default": "rgba(240,240,240,1)" },
        "feNav_line-color": { "default": "rgba(0,0,0,1)" },
        "feNav_icon-color_awy_def": { "default": "rgba(0,0,0,1)" },
        "feNav_line-color_awy_def": { "default": "rgba(0,0,0,1)" },
        "feNav_text-color_awyl": { "default": "rgba(255,255,255,1)" },
        "feNav_line-color_mor": { "default": "rgb(140,140,140)" },
        "feNav_line-color_overwater": { "default": "rgba(65,105,225,0.7)" },
        "feNav_text-color_mor_def": { "default": "rgba(0,170,0,1)" },
        "feNav_text-color_aspl": { "default": "rgb(21,23,94)" },
        "feNav_text-color_sual": { "default": "rgb(21,23,94)" },
        "feNav_text-color_hldl": { "default": "rgb(240,240,240)" }
    },
    "layers": [
        {
            "id": "tiles",
            "source": "raster-tiles",
            "type": "raster"
        }
    ],
    "created": "2021-06-01T00:00:00Z",
    "modified": "2021-06-01T00:00:00Z",
    "id": "FE-Satellite"
}
